
import NcInputNumber from "components/NcInputNumber";
import Prices from "components/Prices";
import { Product } from "data/data";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";

import ContactInfo from "./../PageCheckout/ContactInfo";

import { useCartDataProvider } from "contaxt/CartProductContext";
import { CheckIcon, NoSymbolIcon } from "@heroicons/react/24/solid";

const UserDetails = () => {
  const { Products, dispatch }: any = useCartDataProvider();
  const [tabActive, setTabActive] = useState<
    "ContactInfo" | "ShippingAddress" | "PaymentMethod"
  >("ContactInfo");
  const navigate = useNavigate();

  const renderStatusSoldout = () => {
    return (
      <div className="rounded-full flex items-center justify-center px-2.5 py-1.5 text-xs text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-slate-700">
        <NoSymbolIcon className="w-3.5 h-3.5" />
        <span className="ml-1 leading-none">Unavailable</span>
      </div>
    );
  };

  const renderStatusInstock = () => {
    return (
      <div className="rounded-full flex items-center justify-center px-2.5 py-1.5 text-xs text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-slate-700">
        <CheckIcon className="w-3.5 h-3.5" />
        <span className="ml-1 leading-none">Available</span>
      </div>
    );
  };

  const handleScrollToEl = (id: string) => {
    const element = document.getElementById(id);
    setTimeout(() => {
      element?.scrollIntoView({ behavior: "smooth" });
    }, 80);
  };

  const calculatingTotalPrice = (item: Product) => {
    const { onlinePrice, quantity, note,modifierChecked, modifierSets } = item;
    let allPrice = onlinePrice;

    if (modifierSets) {
      modifierSets.forEach((modifierSets) => {
        const matchingKey =
          modifierChecked &&
          Object.keys(modifierChecked)?.find(
            (key) => Number(key) === modifierSets.id
          );
        if (matchingKey) {
          modifierSets.modifierSetModifierItems?.forEach((modifierItem) => {
            const modifierItemId = modifierItem.id.toString();
            if (modifierChecked[matchingKey]?.[modifierItemId] !== undefined) {
              allPrice += modifierChecked[matchingKey][modifierItemId]
                ? modifierItem.modifierItem.onlinePrice
                : 0;
            }
          });
        }
      });
    }
    let basePrice = quantity ? allPrice * quantity : allPrice;
    return basePrice;
  };

  const allProductPrice = Products.reduce(
    (accumulator: number, currentValue: Product) =>
      accumulator + calculatingTotalPrice(currentValue),
    0
  ).toFixed(2);
  const amtTax = allProductPrice * (8.25 / 100);
  console.log(amtTax, allProductPrice, "tax");
  const totAmt = parseFloat(allProductPrice) + amtTax;
  console.log(totAmt, "total");
  const renderProduct = (item: Product, index: number) => {
    const {
      imageUrl,
      price,
      onlinePrice,
      name,
      id,
      isAvailable,
      quantity,
      note,
      modifierChecked,
      modifierSets,
    } = item;

    return (
      <div
        key={index}
        className="relative flex py-8 sm:py-10 xl:py-12 first:pt-0 last:pb-0"
      >
        <div className="relative h-36 w-24 sm:w-32 flex-shrink-0 overflow-hidden rounded-xl bg-slate-100">
          <img
            src={imageUrl}
            alt={name}
            className="h-full w-full object-contain object-center"
          />
          <button
            onClick={() =>
              navigate(`/${merchantname}/product-detail/${id}`, {
                state: modifierChecked,
              })
            }
            className="absolute inset-0"
          ></button>
        </div>
        <div className="ml-3 sm:ml-6 flex flex-1 flex-col">
          <div>
            <div className="flex justify-between ">
              <div className="flex-[1.5] ">
                <h3 className="text-base font-semibold">{name}</h3>
                <div className="mt-1.5 sm:mt-2.5 flex text-sm text-slate-600 dark:text-slate-300">
                  <div className="flex items-center space-x-1.5"></div>
                  <span className="mx-4 border-l border-slate-200 dark:border-slate-700 "></span>
                  <div className="flex items-center space-x-1.5"></div>
                </div>

                <div className="mt-3 flex justify-between w-full sm:hidden relative">
                  {/* <select
                    name="qty"
                    id="qty"
                    className="form-select text-sm rounded-md py-1 border-slate-200 dark:border-slate-700 relative z-10 dark:bg-slate-800 "
                  >
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                  </select> */}
                  <Prices
                    contentClass="py-1 px-2 md:py-1.5 md:px-2.5 text-sm font-medium h-full"
                    onlinePrice={quantity ? onlinePrice * quantity : onlinePrice}
                  />
                </div>
              </div>

              <div className="hidden sm:block text-center relative">
                <NcInputNumber
                  className="relative z-10"
                  quantity={quantity}
                  note={note}
                  id={id}
                />
              </div>

              <div className="hidden flex-1 sm:flex justify-end">
                <Prices
                  onlinePrice={calculatingTotalPrice(item)}
                  className="mt-0.5"
                />
              </div>
            </div>
          </div>

          {modifierSets?.map((item) => {
            const matchingKey =
              modifierChecked &&
              Object.keys(modifierChecked)?.find(
                (key) => Number(key) === item.id
              );
            if (matchingKey) {
              let totalPrice = 0;
              item.modifierSetModifierItems?.forEach((modifierItem) => {
                const modifierItemId = modifierItem.id.toString();
                if (modifierChecked[matchingKey]?.[modifierItemId]) {
                  totalPrice += modifierItem.modifierItem.onlinePrice;
                }
              });
              return (
                <div key={item.id} className="flex flex-col">
                  {item.modifierSetModifierItems?.some((modifierItem) =>
                    Object.entries(modifierChecked[matchingKey]).some(
                      ([key, value]) =>
                        value === true && modifierItem.id === Number(key)
                    )
                  ) && (
                    <h1 className="text-sm font-bold">
                      {item.name}:- ${totalPrice}
                    </h1>
                  )}
                  <div className="flex flex-wrap">
                    {item.modifierSetModifierItems?.map((modifierItem) => {
                      return (
                        <React.Fragment key={modifierItem.id}>
                          {Object.entries(modifierChecked[matchingKey])
                            .filter(([_, value]) => value === true)
                            .map(([innerKey]) => {
                              if (modifierItem.id === Number(innerKey)) {
                                return (
                                  <h1 key={innerKey} className="text-sm mr-4">
                                    {modifierItem.modifierItem.name}
                                  </h1>
                                );
                              }
                              return null;
                            })}
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              );
            }
            return null;
          })}

          <div className="flex mt-auto pt-4 items-end justify-between text-sm">
            {/* {isAvailable ? renderStatusInstock() : renderStatusSoldout()} */}

            <a
              href="##"
              className="relative z-10 flex items-center mt-3 font-medium text-primary-6000 hover:text-primary-500 text-sm"
              onClick={() => dispatch({ type: "REMOVE_ITEMS", payload: id })}
            >
              <span>Remove</span>
            </a>
          </div>
        </div>
      </div>
    );
  };

  const renderLeft = () => {
    return (
      <div className="space-y-8">
        <div id="ContactInfo" className="scroll-mt-24">
          <ContactInfo
            isActive={tabActive === "ContactInfo"}
            onOpenActive={() => {
              setTabActive("ContactInfo");
              handleScrollToEl("ContactInfo");
            }}
            onCloseActive={() => {
              setTabActive("ShippingAddress");
              handleScrollToEl("ShippingAddress");
            }}
          />
        </div>

        {/* <div id="ShippingAddress" className="scroll-mt-24">
          <ShippingAddress
            isActive={tabActive === "ShippingAddress"}
            onOpenActive={() => {
              setTabActive("ShippingAddress");
              handleScrollToEl("ShippingAddress");
            }}
            onCloseActive={() => {
              setTabActive("PaymentMethod");
              handleScrollToEl("PaymentMethod");
            }}
          />
        </div>

        <div id="PaymentMethod" className="scroll-mt-24">
          <PaymentMethod
            isActive={tabActive === "PaymentMethod"}
            onOpenActive={() => {
              setTabActive("PaymentMethod");
              handleScrollToEl("PaymentMethod");
            }}
            onCloseActive={() => setTabActive("PaymentMethod")}
          />
        </div> */}
      </div>
    );
  };
  const MERCHANT_STORAGE_KEY = "merchantname";
  const merchantname = localStorage.getItem(MERCHANT_STORAGE_KEY);
  console.log(merchantname, "name");
  return (
    <div className="nc-CheckoutPage">
      <Helmet>
        <title>Basil POS Online Ordering</title>
      </Helmet>

      <main className="container py-16 lg:pb-28 lg:pt-20 ">
        <div className="mb-16">
          <h2 className="block text-2xl sm:text-3xl lg:text-4xl font-semibold ">
            User Details
          </h2>
          <div className="block mt-3 sm:mt-5 text-xs sm:text-sm font-medium text-slate-700 dark:text-slate-400">
            <Link to={`/${merchantname}`} className="">
              Menu
            </Link>
            <span className="text-xs mx-1 sm:mx-1.5">/</span>
            <Link to={`/${merchantname}/cart`} className="">
              Cart
            </Link>
            <span className="text-xs mx-1 sm:mx-1.5">/</span>
            {/* <Link to={"/#"} className="">
              Clothing Categories
            </Link> */}
            {/* <span className="text-xs mx-1 sm:mx-1.5">/</span> */}
            <span className="underline">User Details</span>
            <span className="text-xs mx-1 sm:mx-1.5">/</span>
            <Link to={`/${merchantname}/checkout`} className="">
              Checkout
            </Link>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row">
          <div className="flex-1">{renderLeft()}</div>

          <div className="flex-shrink-0 border-t lg:border-t-0 lg:border-l border-slate-200 dark:border-slate-700 my-10 lg:my-0 lg:mx-10 xl:lg:mx-14 2xl:mx-16 "></div>
        </div>
      </main>
    </div>
  );
};

export default UserDetails;
